import script from "./ProductDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=26f7351a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f7351a"]])

export default __exports__